import { Portal } from '@chakra-ui/react';
import { Box } from '@components/ui/atoms/Box';
import { Flex } from '@components/ui/atoms/Flex';
import {
  ChevronLeftGhostWhiteIcon,
  ChevronRightGhostWhiteIcon,
  Icon,
} from '@components/ui/atoms/Icons';

import { useSideBar } from '../hooks';

export const SideBarButton: React.FC = () => {
  const { toggleSideBar, isExpanded } = useSideBar();

  return (
    <Portal>
      <Box
        as="button"
        data-sidebar-toggle-button
        onClick={toggleSideBar}
        cursor="pointer"
        position="fixed"
        left={isExpanded ? '200px' : '70px'}
        top="60px"
        w="40px"
        h="40px"
        display="flex"
        alignItems="center"
        justifyContent="center"
        zIndex={3}
        bg="transparent"
        border="none"
        outline="none"
        p="0"
        css={{
          'body[data-blur-overlay-active] &': {
            display: 'none',
          },
          'body[data-error-page-active] &': {
            display: 'none',
          },
        }}
        _focus={{ outline: 'none' }}
      >
        <Flex
          bg="linear-gradient(90deg, #8571D5 0%, #5031CD 100%)"
          borderRadius="full"
          h="20px"
          w="20px"
          alignItems="center"
          justifyContent="center"
          pointerEvents="none"
        >
          {isExpanded ? (
            <Icon css={{ width: '12px', height: '12px' }}>
              <ChevronLeftGhostWhiteIcon />
            </Icon>
          ) : (
            <Icon css={{ width: '12px', height: '12px' }}>
              <ChevronRightGhostWhiteIcon />
            </Icon>
          )}
        </Flex>
      </Box>
    </Portal>
  );
};
